import React from 'react';
import _ from 'lodash';
import { Table } from 'antd/lib';

const colums = [
  {
    title: 'Tipo Sello',
    dataIndex: ['tipo_sello', 'nombre'],
  },
  {
    title: 'Precio',
    dataIndex: ['tipo_sello', 'valor'],
    render: text =>
      text.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' }),
  },
  {
    title: 'Stock',
    dataIndex: 'cantidad',
  },
  {
    title: 'Sub Total',
    dataIndex: 'subtotal',
    render: (text, record) =>
      (record.tipo_sello.valor * record.cantidad).toLocaleString('es-AR', {
        style: 'currency',
        currency: 'ARS',
      }),
  },
];

class TablaStockDelDia extends React.Component {
  render() {
    let datos = this.props.tipo_sellos;
    if (datos) {
      datos = _.orderBy(datos, ['tipo_sello[valor]'], ['asc']);
    }
    return (
      <Table
        bordered
        loading={this.props.loading}
        pagination={false}
        style={{ maxWidth: 650, marginLeft: '20%', marginTop: 20 }}
        dataSource={datos}
        columns={colums}
        rowKey={record => record.tipo_sello._id}
        locale={{
          emptyText: 'Sin datos de stock.',
        }}
      />
    );
  }
}

export default TablaStockDelDia;
